// extracted by mini-css-extract-plugin
module.exports = {"main":"BorderedBox_main__JPtpL"};